import styled from 'styled-components';


export const Div = styled.div`
    width: min(600px, 100%);
    height: 500px;
    @media (max-width: 768px) {
      height: 280px;
    }
    svg {
      width: 100%;
      height: 100%;
    }
`